import { css } from 'emotion';

export const header = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  align-items: center;
`;

export const sliderWrapper = css`
  margin: 23px 20px 0;
`;

export const dividerWrapper = css`
  && {
    margin: 10px 0 20px;
  }
`;

export const clearFilterStyle = (hidden: boolean) => css`
  margin-top: 30px;
  ${hidden && 'visibility: hidden'};
`;
